import { render, staticRenderFns } from "./user-choose-btn.vue?vue&type=template&id=132d0331&"
import script from "./user-choose-btn.vue?vue&type=script&lang=js&"
export * from "./user-choose-btn.vue?vue&type=script&lang=js&"
import style0 from "./user-choose-btn.vue?vue&type=style&index=0&id=132d0331&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports